import React from "react";
import Modal from "react-bootstrap/Modal";

export interface WarningDialogAction {
  label: string;
  onClick: () => void;
  variant?: "primary" | "secondary";
}

export default function FormsConfigurationSourceWarningDialog(props: {
  text: string | JSX.Element;
  cancelFunc: () => void;
  cancelText: string;
  actions: WarningDialogAction[];
  title?: string;
  bodyComponent?: React.ReactElement;
}) {
  const titleId = "forms-configuration-source-warning";

  return (
    <Modal show={true} size="lg" aria-labelledby={titleId} centered onHide={props.cancelFunc}>
      <Modal.Header closeButton>
        <Modal.Title id={titleId}>{props.title ? props.title : "Warning"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{props.text}</p>
        {props.bodyComponent ? <div className="pt-3 pl-3">{props.bodyComponent}</div> : null}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={props.cancelFunc}>
          {props.cancelText}
        </button>
        {props.actions.map(action => (
          <button
            key={action.label}
            type="button"
            className={`btn btn-${action.variant || "secondary"}`}
            onClick={action.onClick}
          >
            {action.label}
          </button>
        ))}
      </Modal.Footer>
    </Modal>
  );
}
